/**
 * Sets of parameters for generating reasonable-looking demo data in GenerateDataLogEvents.jsx
 */


export const demoDomains = [
	"thefreedictionary.com",
	"boredpanda.com",
	"makeuseof.com",
	"mirror.co.uk",
	"msn.com",
	"businessinsider.com",
	"cyclingnews.com",
	"macworld.co.uk",
	"techradar.com",
	"whathifi.com",
	"metro.co.uk",
	"tomsguide.com",
	"bbcgoodfood.com",
	"livestrong.com",
	"thekitchn.com",
	"independent.co.uk",
	"timeout.com",
	"investing.com",
	"doityourself.com",
	"laptopmag.com",
	"fashionbeans.com",
	"lse.co.uk",
	"whatculture.com",
	"t3.com",
	"yahoo.com",
	"olivemagazine.com",
	"ehow.com",
	"townandcountrymag.com",
	"cnn.com",
	"elle.com",
];

export const demoLocnsUK = [
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-BKM" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-CAM" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-CMA" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-DBY" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-DEV" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-DOR" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-ESX" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-ESS" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-GLS" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-HAM" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-HRT" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-KEN" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-LAN" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-LEC" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-LIN" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-NFK" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-NYK" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-NTH" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-NTT" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-OXF" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-SOM" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-STS" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-SFK" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-SRY" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-WAR" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-WSX" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-WOR" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-LND" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-BDG" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-BNE" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-BEX" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-BEN" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-BRY" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-CMD" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-CRY" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-EAL" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-ENF" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-GRE" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-HCK" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-HMF" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-HRY" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-HRW" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-HAV" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-HIL" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-HNS" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-ISL" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-KEC" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-KTT" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-LBH" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-LEW" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-MRT" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-NWM" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-RDB" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-RIC" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-SWK" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-STN" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-TWH" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-WFT" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-WND" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-WSM" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-BNS" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-BIR" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-BOL" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-BRD" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-BUR" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-CLD" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-COV" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-DNC" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-DUD" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-GAT" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-KIR" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-KWL" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-LDS" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-LIV" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-MAN" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-NET" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-NTY" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-OLD" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-RCH" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-ROT" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-SHN" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-SLF" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-SAW" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-SFT" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-SHF" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-SOL" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-STY" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-SKP" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-SND" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-TAM" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-TRF" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-WKF" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-WLL" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-WGN" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-WRL" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-WLV" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-BAS" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-BDF" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-BBD" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-BPL" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-BCP" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-BRC" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-BNH" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-BST" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-CBF" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-CHE" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-CHW" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-CON" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-DAL" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-DER" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-DUR" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-ERY" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-HAL" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-HPL" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-HEF" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-IOW" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-IOS" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-KHL" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-LCE" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-LUT" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-MDW" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-MDB" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-MIK" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-NEL" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-NLN" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-NSM" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-NBL" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-NGM" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-PTE" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-PLY" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-POR" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-RDG" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-RCC" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-RUT" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-SHR" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-SLG" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-SGC" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-STH" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-SOS" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-STT" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-STE" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-SWD" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-TFW" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-THR" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-TOB" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-WRT" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-WBK" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-WIL" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-WNM" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-WOK" },
	{ country: "GB", locn_sub1: "GB-ENG", locn_sub2: "GB-YOR" },
	{ country: "GB", locn_sub1: "GB-NIR", locn_sub2: "GB-ANN" },
	{ country: "GB", locn_sub1: "GB-NIR", locn_sub2: "GB-AND" },
	{ country: "GB", locn_sub1: "GB-NIR", locn_sub2: "GB-ABC" },
	{ country: "GB", locn_sub1: "GB-NIR", locn_sub2: "GB-BFS" },
	{ country: "GB", locn_sub1: "GB-NIR", locn_sub2: "GB-CCG" },
	{ country: "GB", locn_sub1: "GB-NIR", locn_sub2: "GB-DRS" },
	{ country: "GB", locn_sub1: "GB-NIR", locn_sub2: "GB-FMO" },
	{ country: "GB", locn_sub1: "GB-NIR", locn_sub2: "GB-LBC" },
	{ country: "GB", locn_sub1: "GB-NIR", locn_sub2: "GB-MEA" },
	{ country: "GB", locn_sub1: "GB-NIR", locn_sub2: "GB-MUL" },
	{ country: "GB", locn_sub1: "GB-NIR", locn_sub2: "GB-NMD" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-ABE" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-ABD" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-ANS" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-AGB" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-CLK" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-DGY" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-DND" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-EAY" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-EDU" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-ELN" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-ERW" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-EDH" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-ELS" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-FAL" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-FIF" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-GLG" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-HLD" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-IVC" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-MLN" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-MRY" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-NAY" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-NLK" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-ORK" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-PKN" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-RFW" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-SCB" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-ZET" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-SAY" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-SLK" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-STG" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-WDU" },
	{ country: "GB", locn_sub1: "GB-SCT", locn_sub2: "GB-WLN" },
	{ country: "GB", locn_sub1: "GB-WLS", locn_sub2: "GB-BGW" },
	{ country: "GB", locn_sub1: "GB-WLS", locn_sub2: "GB-BGE" },
	{ country: "GB", locn_sub1: "GB-WLS", locn_sub2: "GB-CAY" },
	{ country: "GB", locn_sub1: "GB-WLS", locn_sub2: "GB-CRF" },
	{ country: "GB", locn_sub1: "GB-WLS", locn_sub2: "GB-CMN" },
	{ country: "GB", locn_sub1: "GB-WLS", locn_sub2: "GB-CGN" },
	{ country: "GB", locn_sub1: "GB-WLS", locn_sub2: "GB-CWY" },
	{ country: "GB", locn_sub1: "GB-WLS", locn_sub2: "GB-DEN" },
	{ country: "GB", locn_sub1: "GB-WLS", locn_sub2: "GB-FLN" },
	{ country: "GB", locn_sub1: "GB-WLS", locn_sub2: "GB-GWN" },
	{ country: "GB", locn_sub1: "GB-WLS", locn_sub2: "GB-AGY" },
	{ country: "GB", locn_sub1: "GB-WLS", locn_sub2: "GB-MTY" },
	{ country: "GB", locn_sub1: "GB-WLS", locn_sub2: "GB-MON" },
	{ country: "GB", locn_sub1: "GB-WLS", locn_sub2: "GB-NTL" },
	{ country: "GB", locn_sub1: "GB-WLS", locn_sub2: "GB-NWP" },
	{ country: "GB", locn_sub1: "GB-WLS", locn_sub2: "GB-PEM" },
	{ country: "GB", locn_sub1: "GB-WLS", locn_sub2: "GB-POW" },
	{ country: "GB", locn_sub1: "GB-WLS", locn_sub2: "GB-RCT" },
	{ country: "GB", locn_sub1: "GB-WLS", locn_sub2: "GB-SWA" },
	{ country: "GB", locn_sub1: "GB-WLS", locn_sub2: "GB-TOF" },
	{ country: "GB", locn_sub1: "GB-WLS", locn_sub2: "GB-VGL" },
	{ country: "GB", locn_sub1: "GB-WLS", locn_sub2: "GB-WRX" }
];

export const demoLocnsUS = [
	{ country: "US", locn_sub1: "US-AL" },
	{ country: "US", locn_sub1: "US-AK" },
	{ country: "US", locn_sub1: "US-AZ" },
	{ country: "US", locn_sub1: "US-AR" },
	{ country: "US", locn_sub1: "US-CA" },
	{ country: "US", locn_sub1: "US-CO" },
	{ country: "US", locn_sub1: "US-CT" },
	{ country: "US", locn_sub1: "US-DE" },
	{ country: "US", locn_sub1: "US-FL" },
	{ country: "US", locn_sub1: "US-GA" },
	{ country: "US", locn_sub1: "US-HI" },
	{ country: "US", locn_sub1: "US-ID" },
	{ country: "US", locn_sub1: "US-IL" },
	{ country: "US", locn_sub1: "US-IN" },
	{ country: "US", locn_sub1: "US-IA" },
	{ country: "US", locn_sub1: "US-KS" },
	{ country: "US", locn_sub1: "US-KY" },
	{ country: "US", locn_sub1: "US-LA" },
	{ country: "US", locn_sub1: "US-ME" },
	{ country: "US", locn_sub1: "US-MD" },
	{ country: "US", locn_sub1: "US-MA" },
	{ country: "US", locn_sub1: "US-MI" },
	{ country: "US", locn_sub1: "US-MN" },
	{ country: "US", locn_sub1: "US-MS" },
	{ country: "US", locn_sub1: "US-MO" },
	{ country: "US", locn_sub1: "US-MT" },
	{ country: "US", locn_sub1: "US-NE" },
	{ country: "US", locn_sub1: "US-NV" },
	{ country: "US", locn_sub1: "US-NH" },
	{ country: "US", locn_sub1: "US-NJ" },
	{ country: "US", locn_sub1: "US-NM" },
	{ country: "US", locn_sub1: "US-NY" },
	{ country: "US", locn_sub1: "US-NC" },
	{ country: "US", locn_sub1: "US-ND" },
	{ country: "US", locn_sub1: "US-OH" },
	{ country: "US", locn_sub1: "US-OK" },
	{ country: "US", locn_sub1: "US-OR" },
	{ country: "US", locn_sub1: "US-PA" },
	{ country: "US", locn_sub1: "US-RI" },
	{ country: "US", locn_sub1: "US-SC" },
	{ country: "US", locn_sub1: "US-SD" },
	{ country: "US", locn_sub1: "US-TN" },
	{ country: "US", locn_sub1: "US-TX" },
	{ country: "US", locn_sub1: "US-UT" },
	{ country: "US", locn_sub1: "US-VT" },
	{ country: "US", locn_sub1: "US-VA" },
	{ country: "US", locn_sub1: "US-WA" },
	{ country: "US", locn_sub1: "US-WV" },
	{ country: "US", locn_sub1: "US-WI" },
	{ country: "US", locn_sub1: "US-WY" },
	{ country: "US", locn_sub1: "US-DC" },
	{ country: "US", locn_sub1: "US-AS" },
	{ country: "US", locn_sub1: "US-GU" },
	{ country: "US", locn_sub1: "US-MP" },
	{ country: "US", locn_sub1: "US-PR" },
	{ country: "US", locn_sub1: "US-UM" },
	{ country: "US", locn_sub1: "US-VI" },
];

// duplicate items to fix underrepresentation of iOS and Android
export const demoDeviceCombos = [
	{ os: 'ios', browser: 'safari' },
	{ os: 'ios', browser: 'safari' },
	{ os: 'ios', browser: 'safari' },
	{ os: 'windows', browser: 'chrome' },
	{ os: 'windows', browser: 'firefox' },
	{ os: 'windows', browser: 'edge' },
	{ os: 'mac os x', browser: 'chrome' },
	{ os: 'mac os x', browser: 'firefox' },
	{ os: 'mac os x', browser: 'safari' },
	{ os: 'android', browser: 'chrome' },
	{ os: 'android', browser: 'chrome' },
	{ os: 'android', browser: 'firefox' },
];